<div class="entity-management-attributes">
    <GenericEntityAttribute
      :items="attributes"
      :loading="loading"
      title="Entity Required Fields"
      description="Manage your entity type attributes and questions"
      :columns="columns"
      :actions="['delete']"
      create-button-text="Assign Question"
      @create="show_create_modal=true"
      @edit="open_edit_modal"
      @view="view_attribute"
      @delete="delete_attribute"
    >

      <!-- Custom Column for Question Type -->
      <template #column-question_type="{ value }">
        <span class="question-type-text">
          {{ format_question_type(value) }}
        </span>
      </template>

      <!-- Custom Empty State -->
      <template #empty-state>
        <div class="text-center py-5 border table-border-color rounded-lg shadow-sm">
          <i class="fa fa-question-circle fa-3x text-muted mb-3"></i>
          <p class="text-muted text-xs">No Required Fields Configured</p>
          <p class="text-muted text-xs">Start by assigning your first question as a required field</p>
        </div>
      </template>
    </GenericEntityAttribute>
</div>

    <!-- Assign Questions Modal -->
<teleport to="body">
<div v-if="show_create_modal" class="modal fade show d-block" tabindex="-1" aria-labelledby="assign_questions_modal_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content bg-white rounded-3 p-0 ">
      <div class="modal-header border-bottom-0 cute-header">
        <p class="modal-title text-white text-xxs" id="assign_questions_modal_label">
          Assign Questions
        </p>
        <button type="button" class="modal-btn-close btn-close" @click="close_create_modal" aria-label="Close"></button>
      </div>

        <div class="modal-body py-3">
          <div class="card mb-4 border-0">
            <div class="card-body p-0">

              <!-- Loading State -->
              <div v-if="questions_loading" class="text-center py-4">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p class="text-muted mt-2 text-xs">Loading questions...</p>
              </div>

              <!-- Questions Table -->
              <div v-else>
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <p class="text-muted mb-0 text-xxs">
                    Toggle to assign or unassign questions as required fields.
                  </p>
                  <div class="input-group input-group-sm w-auto text-xxs">
                    <input 
                      type="text" 
                      class="form-control form-control-sm rounded-lg text-xxs" 
                      placeholder="Search questions..." 
                      v-model="question_search"
                    >
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table table-bordered table-hover align-middle">
                    <thead class="table-header text-white">
                      <tr class="text-xs">
                        <th>Question</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th class="text-center w-auto">Assign</th> <!-- Moved to right -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="question in filtered_questions" :key="question.id" class="text-xxs">
                        <td>{{ question.question_text || 'No question text' }}</td>
                        <td>
                          <span class="question-type-text">
                            {{ format_question_type(question.question_type) }}
                          </span>
                        </td>
                        <td>
                          <span class="status-badge" :class="{ 'bg-success text-white': is_question_assigned(question.id), 'bg-secondary text-white': !is_question_assigned(question.id) }">
                            {{ is_question_assigned(question.id) ? 'Assigned' : 'Unassigned' }}
                          </span>
                        </td>
                        <td class="text-center">
                          <div class="form-check form-switch d-flex justify-content-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              role="switch"
                              :id="'toggle-' + question.id"
                              :checked="is_question_assigned(question.id)"
                              :disabled="save_loading"
                              @change="on_toggle_assign(question)"
                            >
                          </div>
                        </td>
                      </tr>
                      <tr v-if="filtered_questions.length === 0 && !questions_loading">
                        <td colspan="4" class="text-center py-3 text-muted text-xxs">
                          {{ available_questions.length === 0 ? 'No questions available' : 'No matching questions found' }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="d-flex justify-content-between align-items-center mt-3">
                  <small class="text-muted text-xxs">
                    Showing {{ filtered_questions.length }} of {{ available_questions.length }} questions
                  </small>
                  <div class="assignment-stats">
                    <small class="text-xxs fw-bold">
                      {{ assigned_count }} assigned • {{ unassigned_count }} unassigned
                    </small>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button 
          type="button" 
          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" 
          @click="save_assignments"
          :disabled="save_loading || !has_changes"
        >
          <span v-if="save_loading" class="spinner-border spinner-border-sm me-2"></span>
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>
<div v-if="show_create_modal" class="fade show"></div> 
</teleport>